<template>
  <div
    v-if="mostrar"
    class="modal-overlay"
    @click.self="$emit('cancelar')"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h3>Confirmação de Segurança</h3>
        <button
          class="close-btn"
          @click="$emit('cancelar')"
        >
          ✕
        </button>
      </div>

      <div class="modal-body">
        <p>
          Para modificar as credenciais deste usuário, por favor confirme sua
          senha de acesso (SIGAA/GEX).
        </p>
        <div class="input-group">
          <label for="senha">Sua Senha:</label>
          <input
            id="senha"
            type="password"
            v-model="senha"
            placeholder="Digite sua senha"
            @keyup.enter="confirmar"
            ref="inputSenha"
          />
        </div>
        <p
          v-if="erro"
          class="msg-erro"
        >
          {{ erro }}
        </p>
      </div>

      <div class="modal-footer">
        <button
          class="btn-cancelar"
          @click="$emit('cancelar')"
          :disabled="carregando"
        >
          Cancelar
        </button>
        <button
          class="btn-confirmar"
          @click="confirmar"
          :disabled="!senha || carregando"
        >
          {{ carregando ? "Verificando..." : "Confirmar" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from "vue";

const props = defineProps({
  mostrar: Boolean,
  carregando: Boolean,
  erro: String,
});

const emit = defineEmits(["confirmar", "cancelar"]);

const senha = ref("");
const inputSenha = ref(null);

watch(
  () => props.mostrar,
  (novoValor) => {
    if (novoValor) {
      senha.value = "";
      nextTick(() => {
        if (inputSenha.value) {
          inputSenha.value.focus();
        }
      });
    }
  }
);

function confirmar() {
  if (senha.value) {
    emit("confirmar", senha.value);
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 450px;
  padding: 0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #48298a;
  color: #fff;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.close-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #fff;
}

.modal-body {
  padding: 24px;
}

.modal-body p {
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 20px;
  line-height: 1.5;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.input-group input {
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.input-group input:focus {
  outline: none;
  border-color: #48298a;
  box-shadow: 0 0 0 2px rgba(72, 41, 138, 0.1);
}

.msg-erro {
  color: #e53935;
  font-size: 0.85rem;
  margin-top: 8px !important;
  margin-bottom: 0 !important;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background: #f8f9fa;
  border-top: 1px solid #eee;
}

.btn-cancelar {
  padding: 8px 16px;
  border: 1px solid #ccc;
  background: #fff;
  color: #555;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancelar:hover:not(:disabled) {
  background: #f1f1f1;
}

.btn-confirmar {
  padding: 8px 16px;
  border: none;
  background: #48298a;
  color: #fff;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-confirmar:hover:not(:disabled) {
  background: #362065;
}

.btn-confirmar:disabled,
.btn-cancelar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
